module.exports = __webpack_public_path__ + "media/images/emblems/Ostermundigen-coat_of_arms-b773f1b8d8d3c5c3e92c2315df8b04d4.svg";